import { persistentAtom } from "@nanostores/persistent";

export const $activeAdminCartId = persistentAtom<string>(
  "activeAdminCartId",
  ""
);

export function setActiveAdminCartId(cartId: string) {
  $activeAdminCartId.set(cartId);
}

export function clearActiveAdminCartId() {
  $activeAdminCartId.set("");
}
